import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Dialog, Form, Link, Select } from 'tdesign-react';
import { fetchClusterRoleOptions } from '@/slices/permissionsSlice';
import { grantPermissions, undatePermissions } from '@/services/topicService';
import useDisableButton from '@/components/DisableWrapper/useDisableButton';
import { deal70101, toTsOptions } from '@/utils/common';

const { FormItem } = Form;

function Modal({
  handleClose,
  topic,
  roleOptions,
  clusterName,
  visible,
  update,
  permissions,
  fetchClusterRoleOptions,
  ...others
}) {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);
  const isUpdate = !!update;

  const confirmBtn = useDisableButton({ loading: submitting, content: '确定' });

  useEffect(() => {
    if (visible) {
      // Role选项
      fetchClusterRoleOptions({ clusterName, type: 'topic', resource: topic });
      // 修改
      if (isUpdate) {
        form.setFieldsValue(update);
      }
    }
    if (!visible) {
      form.reset();
    }
  }, [visible, form, isUpdate, update, fetchClusterRoleOptions, clusterName, topic]);

  const handleSubmit = async ({ validateResult, fields }) => {
    const request = isUpdate ? undatePermissions : grantPermissions;
    if (validateResult === true) {
      setSubmitting(true);
      try {
        const { meta } = await request({ clusterName, topic, ...fields });
        // 主集群创建的资源已在灾备集群存在
        if (meta.code === 70101) {
          deal70101(meta.publicMessage, () => handleSubmit({ validateResult, fields }), {
            url: '/cluster/topic/list',
            topic,
          });
          return;
        }
        handleClose(true);
      } catch (error) {
        console.trace(error);
        throw error;
      } finally {
        setSubmitting(false);
      }
    }
  };

  const doClose = () => handleClose();

  return (
    <Dialog
      header={isUpdate ? '修改权限' : '添加权限'}
      onClose={doClose}
      onConfirm={() => form.submit()}
      confirmBtn={confirmBtn}
      visible={visible}
      width={550}
      {...others}
    >
      <Form
        onSubmit={handleSubmit}
        form={form}
        resetType='initial'
        style={{ width: '80%', paddingBottom: 10 }}
      >
        <FormItem name='role' label='Role' rules={[{ required: true }]}>
          <Select
            disabled={isUpdate}
            options={toTsOptions(roleOptions)}
            placeholder='角色'
            clearable
          />
        </FormItem>
        <TipContainer>
          没找到，点击
          <Link
            theme='primary'
            hover='color'
            size='small'
            target='_blank'
            href={`/cluster/permissions/roles?name=${clusterName}`}
          >
            这里
          </Link>
          添加
        </TipContainer>
        <FormItem name='permissions' label='权限' rules={[{ required: true }]}>
          <Select multiple placeholder='请选择' options={toTsOptions(permissions)} clearable />
        </FormItem>
      </Form>
    </Dialog>
  );
}

export default connect(
  (state) => ({
    roleOptions: state.permissions.roleOptions,
    permissions: state.dict.permissions,
  }),
  {
    fetchClusterRoleOptions,
  },
)(Modal);

const TipContainer = styled.div`
  margin-bottom: 12px;
  margin-left: 100px;
  margin-top: -12px;
  font-size: 12px;
  color: var(--td-text-color-secondary);
`;
